import { declineOnboarding, getOnBoarding } from "../../api/graphql/queries/onBoarding";

import { updateActionErrors } from "./updateErrors";
import { FETCH_ONBOARDING, DECLINE_ONBOARDING } from "../actions/actionTypes";
import graphqlClient from "../../api/axios_interceptor";

const fetchOnboardingMiddleware = async (action) => {
  try {
      const queryResult = await graphqlClient({
          data: {
              query: getOnBoarding(),
          },
      });

      if (queryResult.data.errors) {
          console.error('GraphQL Errors:', queryResult.data.errors);
          action = updateActionErrors(action);
      } else {
          const onBoardingStatsString = queryResult.data.data.onBoardingStats;
          const onBoardingStats = JSON.parse(onBoardingStatsString);

          action = {
              ...action,
              payload: {
                  ...action.payload,
                  numProperties: onBoardingStats.numProperties,
                  propertiesPercentage: onBoardingStats.propertyPercentage,
                  unitsPercentage: onBoardingStats.unitPercentage,
                  tenantsPercentage: onBoardingStats.tenantPercentage,
                  overallPercentage: onBoardingStats.overallPercentage,
                  onBoardingStatus: onBoardingStats.needsOnboarding,
              },
          };
      }
  } catch (error) {
      console.error(error);
      action = updateActionErrors(action);
  }
  return action;
};


const declineOnBoardingMiddleware = async (action) => {
    try {
        const queryResult = await graphqlClient({
          data: {
            query: declineOnboarding(),
          },
        });
        if (queryResult.data.errors) {
          action = updateActionErrors(action, queryResult.data.errors);
        } else {
          const result = queryResult.data.data.success;
          action = {
            ...action,
            payload: {
              ...action.payload,

            },
            errors: queryResult.data.data.errors
          };
        }
      } catch (error) {
        console.error(error);
      }
      return action;
}

export const onBoardingMiddleware = storeAPI => next => async action => {

    switch(action.type){
        case FETCH_ONBOARDING:
            action = await fetchOnboardingMiddleware(action);
            break;
        case DECLINE_ONBOARDING:
            action = await declineOnBoardingMiddleware(action);
            break;
    }
    return next(action);
}